import PropTypes from 'prop-types';
import React from 'react';
import './StripeBadge.css';

const StripeBadge = ({
  variant = 'neutral',
  children,
  icon,
  size = 'md',
  className = '',
  ...props
}) => {
  const classNames = [
    'stripe-badge',
    `stripe-badge-${variant}`,
    `stripe-badge-${size}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classNames} {...props}>
      {icon && <span className="stripe-badge-icon">{icon}</span>}
      {children}
    </span>
  );
};

StripeBadge.propTypes = {
  variant: PropTypes.oneOf(['success', 'warning', 'error', 'info', 'neutral']),
  children: PropTypes.node.isRequired,
  icon: PropTypes.node,
  size: PropTypes.oneOf(['sm', 'md']),
  className: PropTypes.string,
};

export default StripeBadge;

